<template>
  <div
    v-if="show"
    class="fixed inset-0 z-[999] flex items-center justify-center bg-black/80 px-4 backdrop-blur-sm transition-opacity duration-300"
  >
    <div class="relative w-full max-w-3xl bg-[#14181F] border border-[#00F0FF]/20 p-6 md:p-8 rounded-[16px] text-white shadow-[0_0_30px_#00F0FF15]">
      <!-- Close Button -->
      <button
        @click="$emit('close')"
        class="absolute top-4 right-5 text-gray-500 hover:text-[#00F0FF] text-3xl font-bold transition-colors z-10"
      >
        &times;
      </button>

      <!-- Header Row -->
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-xl md:text-2xl font-bold text-white uppercase tracking-widest flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-3 text-[#00F0FF]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          {{ $t('Modal.RaffleTransaction.RaffleHistory') }}
        </h2>
        <div class="px-3 py-1 bg-[#00F0FF]/10 text-[#00F0FF] rounded-md text-[10px] font-bold uppercase tracking-wider border border-[#00F0FF]/20">
          {{ groupedTransactions.length }} {{ $t('Modal.RaffleTransaction.Entries') }}
        </div>
      </div>

      <!-- Transactions Table -->
      <div
        v-if="groupedTransactions.length > 0"
        class="w-full bg-[#1A1D24] rounded-xl border border-white/5 overflow-hidden"
      >
        <div class="w-full overflow-x-auto custom-scroll">
          <div class="min-w-[500px] flex flex-col max-h-[350px]">
            <!-- Table Header -->
            <div class="grid grid-cols-3 gap-4 px-6 py-4 border-b border-white/5 text-[10px] text-gray-500 font-bold uppercase tracking-widest sticky top-0 bg-[#1A1D24] z-10">
              <div>{{ $t('Modal.RaffleTransaction.RaffleName') }}</div>
              <div class="text-center">{{ $t('Modal.RaffleTransaction.Entries') }}</div>
              <div class="text-right">{{ $t('Modal.RaffleTransaction.LatestEntry') }}</div>
            </div>

            <!-- Table Body -->
            <div
              v-for="transaction in groupedTransactions"
              :key="transaction.raffle._id"
              class="grid grid-cols-3 gap-4 px-6 py-4 items-center border-b border-white/5 last:border-b-0 hover:bg-white/[0.02] transition-colors"
            >
              <div class="flex items-center gap-3">
                <span class="text-sm font-bold text-white truncate max-w-[200px]">{{ transaction.raffle.name }}</span>
              </div>
              <div class="text-center text-sm font-black text-[#00F0FF]">
                {{ transaction.entriesCount }}
              </div>
              <div class="text-right text-xs font-bold text-gray-400">
                {{ transaction.latestDate.toLocaleString() }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div v-else class="flex flex-col items-center justify-center py-10 bg-[#1A1D24] rounded-xl border border-white/5">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 text-gray-600 mb-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
        </svg>
        <p class="text-center text-gray-500 font-bold uppercase tracking-widest text-xs">
          {{ $t('Modal.RaffleTransaction.NoPurchases') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    transactions: Array,
  },
  computed: {
    groupedTransactions() {
      const grouped = {};
      this.transactions.forEach((tx) => {
        const raffleId = tx.raffle._id;
        if (!grouped[raffleId]) {
          grouped[raffleId] = {
            ...tx,
            entriesCount: tx.entriesCount,
            latestDate: new Date(tx.createdAt),
          };
        } else {
          grouped[raffleId].entriesCount += tx.entriesCount;
          if (new Date(tx.createdAt) > grouped[raffleId].latestDate) {
            grouped[raffleId].latestDate = new Date(tx.createdAt);
          }
        }
      });
      return Object.values(grouped);
    },
  },
};
</script>

<style scoped>
.custom-scroll::-webkit-scrollbar {
  width: 6px;
}
.custom-scroll::-webkit-scrollbar-track {
  background: #1b2d47;
  border-radius: 10px;
}
.custom-scroll::-webkit-scrollbar-thumb {
  background: #00f0ff;
  border-radius: 10px;
}
.custom-scroll::-webkit-scrollbar-thumb:hover {
  background: #00bbdd;
}
</style>
